import { useChat } from '../context/ChatContext';
import { useAuth } from '../context/AuthContext';
import { isOpsStaff, OPS_KEYS } from '../menuConfig';

// Thanh điều hướng dưới cùng — CHỈ hiện trên mobile (<768px, CSS lo). 5 mục cố định như thiết kế:
// Trang chủ · Tin nhắn · [Chấm công FAB tròn nổi giữa] · KPI · Menu.
// Riêng nhân sự Phòng OP (kho): mục KPI đổi thành VẬN HÀNH (mở danh sách chức năng vận hành) —
// họ dùng cả ngày, còn KPI vẫn vào được qua Menu > Nhân sự & KPI.
export default function MobileNav({ page, setPage }) {
  const { me } = useAuth();
  const chat = useChat();
  const unread = chat?.totalUnread || 0;
  const canAttendance = me && (me.role === 'NV' || me.role === 'TP');
  const opsTab = isOpsStaff(me);

  // FAB chấm công: nhân viên/TP -> màn Chấm công (lịch + nút khuôn mặt); GĐ/CV không chấm công
  // -> đưa sang KPI (xem lịch chấm công toàn phòng).
  const onCham = () => setPage(canAttendance ? 'attendance' : 'kpi');

  const Item = ({ k, ico, label, on }) => (
    <button type="button" className={'mbnav-item' + ((on ?? page === k) ? ' on' : '')} onClick={() => setPage(k)}>
      <span className="mbnav-ico" style={{ position: 'relative' }}>
        <i className={`ti ${ico}`} aria-hidden="true" />
        {k === 'messages' && unread > 0 && <span className="mbnav-badge">{unread > 99 ? '99+' : unread}</span>}
      </span>
      <span className="mbnav-label">{label}</span>
    </button>
  );

  return (
    <nav className="mbnav" aria-label="Điều hướng chính">
      <Item k="dashboard" ico="ti-home" label="Trang chủ" />
      <Item k="messages" ico="ti-message-circle" label="Tin nhắn" />
      {/* FAB chấm công nổi giữa */}
      <button type="button" className={'mbnav-fab' + (page === 'attendance' ? ' on' : '')} onClick={onCham} title="Chấm công" aria-label="Chấm công">
        <i className="ti ti-face-id" aria-hidden="true" />
      </button>
      {opsTab
        ? <Item k="ops" ico="ti-truck-delivery" label="Vận hành" on={page === 'ops' || OPS_KEYS.includes(page)} />
        : <Item k="kpi" ico="ti-chart-bar" label="KPI" />}
      <Item k="menu" ico="ti-menu-2" label="Menu" />
    </nav>
  );
}
